import { initialState, State } from './state';
import { Actions, ActionTypes } from './actions';

export function cardCheckReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.SELECT_CARD_TYPE: {
      return {
        ...state,
        selectedCard: action.payload.card
      };
    }
    case ActionTypes.BIN_SEARCH: {
      return {
        ...state,
        binNumber: action.payload,
        cardSearchOption: 'Search',
        cards: null,
        binFound: null,
        alternativeBin: null
      }
    }
    case ActionTypes.BIN_SEARCH_SUCCESS: {
      return {
        ...state,
        cardSearchOption: 'Card',
        binFound: true,
        cards: action.payload
      }
    }
    case ActionTypes.BIN_SEARCH_NOT_FOUND: {
      return {
        ...state,
        cardSearchOption: 'Bin',
        cards: null,
        binFound: false,
        alternativeBin: false
      }
    }
    case ActionTypes.BIN_SEARCH_FAILURE: {
      return {
        ...state,
        cardSearchOption: 'Bin',
        cards: null
      }
    }
    case ActionTypes.BIN_RESET: {
      return {
        ...state,
        selectedCard: null,
        binNumber: null,
        cardSearchOption: 'Bin',
        cards: null,
        binFound: null,
        alternativeBin: null
      }
    }
    case ActionTypes.ALTERNATIVE_BIN: {
      return {
        ...state,
        cardSearchOption: 'Bin',
        cards: null,
        binFound: null,
        alternativeBin: true
      }
    }
    default:
      return state;
  }
}
